import { toast } from "react-toastify";
import AuthenticationActioner from "./actioner";
import IntlUtils from "services/intl/utils";

class AuthenticationUtils {
  static REFRESH_BEFORE_EXPIRED_TIME = 0; // 2 min

  static isTokenExpired = (token) => {
    if (!token) return true;

    const now = new Date().getTime();
    const expiryDate = token.expires_at * 1000;
    return now > expiryDate - AuthenticationUtils.REFRESH_BEFORE_EXPIRED_TIME;
  };

  static getAccessToken = async () => {
    return new Promise((resolve, reject) => {
      const store = require("../../store").applicationStore;
      const accessToken = store.getState().Authentication.access_token;
      const refreshToken = store.getState().Authentication.refresh_token;

      if (AuthenticationUtils.isTokenExpired(accessToken)) {
        if (AuthenticationUtils.isTokenExpired(refreshToken)) {
          const intl = IntlUtils.getIntlInstance();
          const msg = intl.messages["toast.errors.sessionExpired"];

          toast(msg, {
            position: toast.POSITION.BOTTOM_RIGHT,
            type: toast.TYPE.ERROR,
          });

          store.dispatch(AuthenticationActioner.logout());

          if (accessToken) {
            return reject("Access and Refresh Token are expired");
          }

          return;
        }

        // Should refresh access token using refresh
        return store
          .dispatch(AuthenticationActioner.refreshAuthentication(refreshToken))
          .then((auth) => {
            return resolve(auth.access_token.token);
          });
      }
      return resolve(accessToken.token);
    });
  };

  static shouldPersistSession = (authState) => {
    return (
      authState &&
      (authState.keepLoggedIn ||
        authState.sessionExpiredAt > new Date().getTime())
    );
  };
}

export default AuthenticationUtils;
